module.exports = __webpack_public_path__ + "img/logo_extended.9fb8ecea.svg";